// @flow
import React, { useState } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const RECAPTCHA_SITE_KEY = '6Lfgwp8rAAAAADxRKyFn2IUJUIBWXlj0biM97oxj'; // Your site key

function ReCaptchaProvider({ children }) {
  const [, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = React.useState(null);

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_SITE_KEY}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'body',
        nonce: undefined,
      }}
      onLoadedSuccessfully={() => {
        setIsLoaded(true);
      }}
      onLoadedWithError={(error) => {
        setLoadError(error);
      }}
    >
      {loadError ? (
        <div style={{ padding: '20px', color: 'red', textAlign: 'center' }}>
          reCAPTCHA failed to load. Please check your internet connection and try again.
          <br />
          Error: {loadError.message}
        </div>
      ) : (
        children
      )}
    </GoogleReCaptchaProvider>
  );
}

export default ReCaptchaProvider;
